import React, { useMemo } from 'react'
import { hasBlock, isEmpty } from '../../../services/common'
import { Parser } from '../../common'
import WhereToContactExternalLink from './WhereToContactExternalLink'
import WhereToContactLocation from './WhereToContactLocation'

const WhereToContactItem = ({ block, isPersonnalizedLocal }) => {
    const hasWebRessourceBlock = hasBlock(block?.childrens, 'RessourceWeb')
    const isTypeContent = ['Centre de contact', 'National'].includes(block?.attributes?.type)

    const renderBlockByStyle = useMemo(() => {
        if (hasWebRessourceBlock && !isPersonnalizedLocal) {
            return <WhereToContactExternalLink block={block} />
        } else if (
            block.attributes.pivot_local &&
            block.attributes.type === 'Local personnalisé sur SP'
        ) {
            return (
                <div className="baseocom-where-to-contact-location">
                    <WhereToContactLocation block={block} />
                </div>
            )
        } else {
            return !isEmpty(block?.childrens) ? (
                <div
                    className={`${isTypeContent ? 'baseocom-where-to-contact-item-contact-center-block' : ''}`}
                >
                    <Parser content_block={block?.childrens} attributes={block?.attributes} />
                </div>
            ) : (
                <div
                    className={`${isTypeContent ? 'baseocom-where-to-contact-item-contact-center-block' : ''}`}
                >
                    <Parser
                        content_block={block?.attributes?.original_childrens}
                        attributes={block?.attributes}
                    />
                </div>
            )
        }
    }, [block, isPersonnalizedLocal, hasWebRessourceBlock, isTypeContent])

    return renderBlockByStyle
}

export default WhereToContactItem
